/**
 * Whether an order has likely produced output in Supabase Storage worth
 * linking to.
 *
 * We key this on `workflowRunId` (generation has started → the `{orderId}/`
 * prefix of the `book-outputs` bucket has artifacts) rather than on
 * `generatedPath`. The `generated_path` column is frequently `null` even for
 * fully-generated orders, so gating the storage link on it hid the folder for
 * orders that actually had output. `generatedPath` is kept as a fallback for
 * any legacy rows that have it set without a `workflowRunId`.
 *
 * The link itself is always built from the order id (`?prefix=${id}/`), never
 * from `generated_path`.
 */
export function hasStorageOutput(order: {
  workflowRunId: string | null;
  generatedPath: string | null;
}): boolean {
  return Boolean(order.workflowRunId || order.generatedPath);
}
